import { KissanEventType, useGlobalLoginContext, useProfileStore } from '@ninjacart/nc-nk-store';
import { Stack, Text, TextWrapper, useTheme, View, XStack } from '@ninjacart/nc-nk-ui';
import { ScrollText, Search } from '@tamagui/lucide-icons';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
// import { AnimatableNumericValue, Animated, StyleSheet } from 'react-native';
import { safeStringify } from '@ninjacart/nc-nk-core';
import {
  addEventParam,
  INinjaEvent,
  useQueuedEventStore,
} from '@ninjacart/nc-events-sdk-v2';
import { useRouter } from 'solito/navigation';

export const AnimatedQuestionAnswerHeader = () => {
  const hasUserLoggedIn = useProfileStore((state) => state.hasUserLoggedIn);
  const { push } = useRouter();
  const { t } = useTranslation();
  const theme = useTheme();
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;
  const fields = useGlobalLoginContext(['openLoginSheet','previousPage', 'navigationParams']);
  const setNavigationParams = fields.navigationParams.set;

  const navigateToMyQuestion = () => {
    try {
      const myQuestionClickSuccess: INinjaEvent = {
        name: KissanEventType.QNA_MYQUESCLICK_SUCCESS,
        screenDetails: { screen: 'qna page' },
      };
      enqueue(myQuestionClickSuccess);
      if (!hasUserLoggedIn()) {
        fields['openLoginSheet'].set(true);
        fields['previousPage'].set('QNA page');
        setNavigationParams({
          name: '',
          routeName: { name: 'myQuestionsList/index' },
          description: `${t('page.myQuestionsPage')}`,
          screenName: 'QNA page',
        });
      } else {
        push('/myQuestionsList');
      }
    } catch (error) {
      const myQuestionClickFailed: INinjaEvent = {
        name: KissanEventType.QNA_MYQUESCLICK_FAIL,
        screenDetails: { screen: 'qna page' },
        eventParams: [
          addEventParam('errorMessage', error.toString()),
          addEventParam('apiError', safeStringify(error)),
        ],
      };
      enqueue(myQuestionClickFailed);
    }
  };

  const handleSearch = () => {
    push('/qnaSearch');
    const qnaSearchClickEvent: INinjaEvent = {
      name: KissanEventType.QNA_SEARCH_CLICK,
      screenDetails: { screen: 'question answer page' },
    };
    enqueue(qnaSearchClickEvent);
  };

  return (
    <View
      height={60}
      top={0}
      zIndex={1}
      background={'$background'}
      paddingHorizontal={10}
      paddingVertical={6}
    >
      <XStack display="flex" justifyContent="space-between" alignItems="center" >
        <XStack paddingTop={5}>
          <TextWrapper
            trimValue={0.5}
            languaguesToTrim={['ta', 'kn', 'mr', 'ml']}
            color="$primary"
            fontSize={18}
            fontWeight="600"
            paddingTop={2}
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {t('page.qna')}
          </TextWrapper>
        </XStack>

        <XStack padding={6}>
          <Stack
            onPress={navigateToMyQuestion}
            borderRadius={50}
            borderWidth={1}
            borderColor="$primary"
            backgroundColor="$background"
            padding={8}
            flexDirection="row"
            alignItems="center"
            testID='kisan_tId_navigateToMyQuestions'
          >
            <ScrollText color={theme['primary']?.val} size={20} />
            <Text paddingLeft={8} color="$primary" fontWeight="600" fontSize={14}>
              {t('page.myQuestions')}
            </Text>
          </Stack>

          <Stack
            onPress={handleSearch}
            borderRadius={50}
            borderWidth={1}
            borderColor="$primary"
            backgroundColor="$background"
            padding={8}
            marginLeft={2}
            testID='kisan_tId_handleSearch'
          >
            <Search color={theme['primary']?.val} size={22} />
          </Stack>
        </XStack>
      </XStack>
    </View>
  );
};
